import React, { ReactNode } from 'react';

export interface ISelectLabelProps {
  id: string;
  label?: string;
  containerClassname?: string;
  labelClassName?: string;
}

export const SelectLabel = ({
  id,
  containerClassname = '',
  labelClassName = '',
  label,
  children,
}: ISelectLabelProps & { children: ReactNode }) => (
  <div className={containerClassname}>
    {label && (
      <label
        id={`${id}-label`}
        htmlFor={id}
        className={`mb-2 block font-semibold ${labelClassName}`}
      >
        {label}
      </label>
    )}
    {children}
  </div>
);
